import * as React from 'react';

import styles from './QuickFiltersWrapper.css';

export const QuickFiltersWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
